import { render } from "./PosDevicesTab.vue?vue&type=template&id=3d923cf2"
import script from "./PosDevicesTab.vue?vue&type=script&lang=js"
export * from "./PosDevicesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__